import * as webVitals from 'web-vitals'

import {trackEvent} from '../tracking'

const PRECISION_MULTIPLIER = 1000

function preparePerformanceMeasure(metric: webVitals.Metric) {
  const {name} = metric
  const value = Math.round(name === 'CLS' ? metric.value * PRECISION_MULTIPLIER : metric.value)
  trackEvent({
    name: `ui.performance.${name.toLowerCase()}`,
    groupId: 'ui.performance.group',
    data: {value},
  })
}

function measureWebVitals() {
  webVitals.onLCP(preparePerformanceMeasure, {reportAllChanges: true})
  webVitals.onCLS(preparePerformanceMeasure, {reportAllChanges: true})
  webVitals.onFCP(preparePerformanceMeasure)
  webVitals.onTTFB(preparePerformanceMeasure)
}

export default measureWebVitals
